<template>
  <transition name="modal">
    <div class="modal-mask column centered">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-body font-300" v-html="info.description">
            {{info.description}}
          </div>
          <div class="modal-footer">
            <button class="modal-default-button" @click="$emit('close')">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['info']
}
</script>

<style>
.modal-mask {
  background-color: rgba(0, 0, 0, .5);
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  transition: opacity .3s ease;
  width: 100%;
  z-index: 9999;
}

.modal-wrapper {
  max-height: 400px;
  overflow: auto;
  width: 90%;
}

.modal-container {
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  font-family: Helvetica, Arial, sans-serif;
  margin: 0px auto;
  padding: 20px 30px;
  transition: all .3s ease;
  width: 100%;
}

.modal-enter,
.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  transform: scale(1.1);
}

@media only screen and (min-width: 992px) {
  .modal-wrapper {
    max-height: 500px;
    width: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue